import { FC, PropsWithChildren } from 'react';
import { LucideBuilding2 } from 'lucide-react';
import useMediaQuery from '@/hooks/useMediaQuery';
import { AppConfig } from '@/config/app.config';
import { cn } from '@/lib/utils';

type Props = {
	icon?: string;
	title: string;
	description: string;
	onClick: () => void;
};

const HotelCard: FC<PropsWithChildren<Props>> = ({
	icon,
	title,
	description,
	onClick,
}) => {
	const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);

	return (
		<div
			className={cn(
				'py-10 px-6 bg-popover-10 rounded-2xl border-1 border-popover-100 shadow-xs flex flex-col gap-2 cursor-pointer items-center hover:shadow-custom transition-shadow duration-500 ease-in-out',
			)}
			onClick={onClick}>
			<div className={cn(isMobile ? 'size-6' : 'size-8')}>
				{icon ? (
					<img src={icon} />
				) : (
					<LucideBuilding2
						className={cn(isMobile ? 'size-6' : 'size-8')}
					/>
				)}
			</div>
			<div
				className={cn(
					'w-32 flex flex-col justify-center items-center',
					!isMobile && 'gap-0.5',
				)}>
				<div className={cn('h-6 font-medium', isMobile && 'text-sm')}>
					{title}
				</div>
				<div className={cn('h-6 text-gray-400', isMobile && 'text-sm')}>
					{description}
				</div>
			</div>
		</div>
	);
};

export default HotelCard;
